import EcosiaUser from '@ecosia/ecosia-user';

import {
  LAST_DISCARDED_NOTIFICATION as LAST_DISCARDED_NOTIFICATION_COOKIE,
  LAST_READ_NOTIFICATION as LAST_READ_NOTIFICATION_COOKIE,
  MAIN as MAIN_COOKIE,
  CONSENT as CONSENT_COOKIE,
} from '~~/common/js/constants/cookies';
import { DEFAULT_LOCALE } from '~~/common/js/constants/i18n';

export const state = () => ({
  addOn: 0,
  autoSuggest: 1,
  // betaUser is currently needed by indexpage for login beta
  // it should be removed once login is rolled out to all users.
  betaUser: false,
  bingMarketCode: 'en-us',
  browser: '',
  browserDisplay: '',
  browserVersion: '',
  confirmEmail: '',
  consentGiven: false,
  consentVisible: false,
  defaultMarket: '',
  deviceType: 'pc',
  language: DEFAULT_LOCALE,
  lastDiscardedNotification: null,
  lastReadNotificationTimestamp: 0,
  loggedIn: false,
  loginFailed: false,
  newTab: 0,
  notificationEnabled: 1,
  temperatureUnit: 'auto',
  treeCount: 0,
});

export const getters = {
  linkTarget: ({ newTab }) => (newTab ? '_blank' : '_self')
};

export const mutations = {
  set(st, data) {
    Object.assign(st, data);
  },
  setConfirmEmail(st, email) {
    st.confirmEmail = email;
  },
  setBetaUser(st, enabled) {
    st.betaUser = enabled;
  },
  setLoggedIn(st, loggedIn) {
    st.loggedIn = loggedIn;
  },
  setTreeCount(st, treeCount) {
    st.treeCount = treeCount;
  },
};

export const actions = {
  async nuxtServerInit({ commit }, context) {
    const { app, req } = context;
    const user = req.user || new EcosiaUser({
      cookieString: app.$cookies.get(MAIN_COOKIE),
      userAgent: req.headers['user-agent'],
      acceptLanguage: req.headers['accept-language'],
    });

    // TODO: Remove beta flag related logic
    const betaUser = true;

    const lastDiscardedNotification = app.$cookies.get(LAST_DISCARDED_NOTIFICATION_COOKIE);
    const lastReadNotificationTimestamp = app.$cookies.get(LAST_READ_NOTIFICATION_COOKIE);

    const data = {
      addOn: user.get('addOn'),
      autoSuggest: user.get('autoSuggest'),
      betaUser,
      bingMarketCode: user.get('bingMarketCode'),
      browser: user.get('browser'),
      browserDisplay: user.get('browserDisplay'),
      browserVersion: user.get('browserVersion'),
      consentGiven: !!app.$cookies.get(CONSENT_COOKIE),
      defaultMarket: user.get('bingMarketCode'),
      deviceType: user.get('deviceType'),
      language: user.get('language'),
      lastDiscardedNotification,
      lastReadNotificationTimestamp,
      loggedIn: req.loggedIn,
      loginFailed: req.loginFailed,
      newTab: user.get('newTab'),
      notificationEnabled: user.get('notifications'),
      temperatureUnit: user.get('temperatureUnit'),
      treeCount: user.get('treeCount'),
    };

    commit('set', data);
  },
};

export const storeModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default (store) => {
  store.registerModule('user', storeModule);
};
